/**
 * HakedisPenceresiRozeti.jsx
 *
 * Danışman CRM Faz 2 — hakediş kohort penceresini açıklayan ortak rozet.
 *
 * Backend kohort modeli (routes/prim.py, services/tr_time.py):
 *   X ayının (kohort ayı) primi, X ayında AÇILAN satışların X ayı başından
 *   (X+1) ayının 16'sının TR 00:00'ına KADAR ($lt exclusive — "15'i 23:59:59
 *   TR dahil" ile eşdeğer) gerçekleşen tahsilatlarını kapsar. KESİM_GÜNÜ tek
 *   sabit burada tanımlanır — pencere metnini üreten TÜM yerler bu sabiti
 *   kullanır.
 *
 * kuralVar=false verilirse rozet hiç render edilmez (danışman hakediş
 * kartında "prim kuralı tanımlanmadı" durumunda gösterilmemesi için).
 */
import { Popover, PopoverTrigger, PopoverContent } from '../ui/popover';
import { CalendarClock } from 'lucide-react';
import { trNowLocalMonthInput } from '../../utils/trDateTime';

export const KESIM_GUNU = 15;

const AY_ADLARI_TR = [
  'Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran',
  'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık',
];
const AY_ADLARI_EN = [
  'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

function currentMonthStr() {
  return trNowLocalMonthInput();
}

function ayAdi(donem, lang, offset = 0) {
  const [y, m] = donem.split('-').map(Number);
  const d = new Date(Date.UTC(y, m - 1 + offset, 1));
  const idx = d.getUTCMonth();
  return lang === 'tr' ? AY_ADLARI_TR[idx] : AY_ADLARI_EN[idx];
}

export default function HakedisPenceresiRozeti({ tr, lang, donem, kuralVar = true }) {
  if (kuralVar === false) return null;
  const effDonem = donem || currentMonthStr();
  const ayBu = ayAdi(effDonem, lang, 0);
  const aySonraki = ayAdi(effDonem, lang, 1);

  const badgeLabel = tr(
    `${ayBu} kayıtları · ${aySonraki} ayının ${KESIM_GUNU}'ine kadar tahsilat`,
    `${ayBu} enrollments · collections until the ${KESIM_GUNU}th of ${aySonraki}`,
  );

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold"
          style={{ backgroundColor: 'rgba(46,107,143,0.08)', border: '1px solid rgba(46,107,143,0.25)', color: 'var(--crm-info)' }}
        >
          <CalendarClock size={12} /> {badgeLabel}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 text-xs space-y-2" style={{ color: 'var(--crm-navy-text)' }}>
        <p className="font-bold text-sm">{tr('Hakediş penceresi nasıl hesaplanır?', 'How is the earnings window calculated?')}</p>
        <p>
          {tr(
            `${ayBu} primi, ${ayBu} ayında kaydolan öğrencilerin ${aySonraki} ayının ${KESIM_GUNU}'ine kadar yapılan tahsilatlarını kapsar.`,
            `${ayBu}'s commission covers collections made by the ${KESIM_GUNU}th of ${aySonraki} for students enrolled in ${ayBu}.`,
          )}
        </p>
        <p className="italic p-2 rounded-lg" style={{ backgroundColor: 'var(--crm-cream)', color: 'var(--crm-muted)' }}>
          {tr(
            "Örnek: 12 Temmuz kaydı, taksit 20 Ağustos'ta ödendi → Temmuz penceresine girmez.",
            'Example: enrollment on July 12, installment paid on August 20 → does not fall within the July window.',
          )}
        </p>
      </PopoverContent>
    </Popover>
  );
}
